import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface KickInfoState {
  roomId: number;
  isShow: boolean;
  isReload: number;
  banRoomMsg: string;
  list: any[];
}

const LOCALKEY = localKeyInfo.kickInfo;
const localVoiceInfo = LocalStore.getValue<KickInfoState>(LOCALKEY) || {};

export const kickInfo: KickInfoState = {
  roomId: 0,
  isShow: false,
  isReload: 0,
  banRoomMsg: '',
  list: [],
  ...localVoiceInfo
};

export const setKickInfo: (payload: KickInfoState) => IAction<KickInfoState> = (payload: KickInfoState) => ({
  type: 'setKickInfo',
  payload
});

const kickInfoReducer: Reducer<KickInfoState, IAction<any>> = (state = kickInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setKickInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default kickInfoReducer;
